import React,{useState} from 'react'
import { Link } from 'react-router-dom'
import HomeSliderServices from '../services/HomeSliderServices';
import Pagetitle from './PageTitle';

function TrialPeriod() {

  
  const [formValues, setFormValues] = useState({
    title: '',
    link: '',
    sequence: '1',
    image: '',
    userFor: 'Farmer',
  });

  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png'); // Placeholder image path



  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };



  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };
//   // Handle form submission
const handleSubmit = async (event) => {
  event.preventDefault();
  try {
    const formData = new FormData();
    for (const key in formValues) {
      formData.append(key, formValues[key]);
    }

    await HomeSliderServices.createBanner(formData);
    alert('Banner created successfully');
  } catch (error) {
    console.error('Failed to create Banner', error);
    alert('Failed to create home slider');
  }
};

  return (
    <>
    <div className="right_col" role="main">
      <Pagetitle></Pagetitle>
        <div className="container-box">
          <div className="container-box-inner px-4">
            <div className="page-details">
              <form onSubmit={handleSubmit}>
                <div className='row'>
                <div className="col-lg-4 col-md-6">
                <div className="input-field">
                  <label>Trial Period Duration (In Days)</label>
                  <input type="text" name="title"
                        onChange={handleInputChange} placeholder='Enter Days' className="form-control" />
                </div>
                </div>
                <div className="col-lg-4 col-md-6">
                <div className="input-field">
                  <label>Auto-conversion to Paid Plan</label>
                  <div class="status-toggle">
                                <div class="check-box">
                                  <input type="checkbox" name='Auto-conversion'/>
                                </div>
                                <label htmlFor="Auto-conversion">Yes</label>
                            </div>

                </div>
                </div>
                <div className="col-lg-4 col-md-6">
                <div className="input-field">
                  <label>Notification Settings</label>
                  <div class="status-toggle">
                      <div class="check-box">
                        <input type="checkbox" name='Notification Settings'/>
                      </div>
                      <label htmlFor="Notification Settings">Notify user before trial ends</label>
                  </div>
                </div>
                </div>
                  <div className="col-sm-12">
                    <div className="input-field">
                      <label>Terms and Conditions</label>
                      <textarea className="form-control" name="message"  value={formValues.message} 
                        onChange={handleInputChange} placeholder='Terms and Conditions' />                           
                    </div>
                  </div>
                </div>
         
                
                <button className="site-btn-green">SUBMIT</button>

              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TrialPeriod